import { css } from '@emotion/react';
import type { ReactElement } from 'react';
import { memo } from 'react';
import { ChatDialogEvent, ChatSelectionView } from 'sdk';

import { styled } from '../../../../styled';
import { AgentMessageContainer } from '../agentMessage';
import { LinkButton } from './linkButton';
import { SelectionButton } from './selectionButton';

const Component = ({
	message,
	showButtons,
	hideAvatar,
	className,
}: {
	className: string;
	message: ChatDialogEvent;
	showButtons: boolean;
	hideAvatar: boolean;
}): ReactElement => {
	return (
		<div className={className}>
			{message.view.text && (
				<div className="ncc-msg-container">
					<AgentMessageContainer hideAvatar={hideAvatar} message={message} />
				</div>
			)}
			<div>
				{showButtons &&
					(message.view as ChatSelectionView).buttons.map((button) =>
						button.url ? (
							<LinkButton key={button.key} message={message} button={button} />
						) : (
							<SelectionButton key={button.key} message={message} button={button} />
						)
					)}
			</div>
		</div>
	);
};

export const SelectionButtons = memo(
	styled(Component)(
		css`
			& > .ncc-msg-container {
				display: flex;
			}
		`
	)
);
